export const API_BASE_URL = 'https://cleaningmiamipanel.org/api';

export const authHeaders = () => ({
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${localStorage.getItem('token')}`
});

export const authFetch = (url, options = {}) =>
    fetch(url, {
        ...options, 
        headers: {
            ...authHeaders(),
            ...options.headers
        }
    }).then(res => {
        console.log('authFetch response status:', res.status, url)
        if (res.status === 401) {
            if (window.handleUnauthorized) window.handleUnauthorized();
            return;
        }
        return res.json();
    }).then(data => {
        console.log('authFetch response data:', data)
        return data;
    });